import React from "react";
import i18n from '../../i18n';
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import {withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import EllipsisWithTooltip from "../Formater/EllipsisWithTooltip";
import TowLine from "../Text/TwoLine";
import ProjectStatusText from "../Project/ProjectStatusText";
import FormaterDate from "../Formater/Date";
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";
import TableRowClickable from "../Form/TableRowClickable";

const BuildingDeficienciesTable = ({deficiencyBuildings, classes}) => {

    return (
        <React.Fragment>
            <Table className={classes.list}>
                <TableHead>
                    <TableRow style={{background:'unset',}}>
                        <TableCell style={{ width:'50%' }}>{i18n.get('deficiency.self')}</TableCell>
                        <TableCell style={{ width:'15%' }}>{i18n.get('deficiency.status')}</TableCell>
                        <TableCell align="center">{i18n.get('deficiency.reminder')}</TableCell>
                        <TableCell align="center">{i18n.get('deficiency.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    { deficiencyBuildings.map( (deficiencyBuilding) => (
                        <TableRowClickable action={`/project/${deficiencyBuilding.project.id}`} key={`deficiency_${deficiencyBuilding.project.id}`}>
                            <TableCell>
                                <Typography component={'h6'}>
                                    <EllipsisWithTooltip>
                                        {deficiencyBuilding.project.name}
                                    </EllipsisWithTooltip>
                                </Typography>
                                <TowLine
                                    sub={deficiencyBuilding.project.number_internal}
                                />
                            </TableCell>
                            <TableCell>
                                <ProjectStatusText status={deficiencyBuilding.project.status} size="small" />
                            </TableCell>
                            <TableCell align={'center'}>
                                <Typography component={'h6'}>
                                    {deficiencyBuilding.project.reminder && (<FormaterDate value={deficiencyBuilding.project.reminder} />)}
                                </Typography>
                            </TableCell>
                            <TableCell align={'center'} onClick={ e => { e.stopPropagation('all'); } } style={{cursor:'default'}}>
                                <IconButton
                                    component="a"
                                    href={`/project/${deficiencyBuilding.project.id}/edit`}
                                >
                                    <Icon>edit</Icon>
                                </IconButton>
                            </TableCell>
                        </TableRowClickable>
                    ))}
                </TableBody>
            </Table>
        </React.Fragment>
    )
};

const styles = theme => ({
    list: {
        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        },
    },
});

export default withStyles(styles)(BuildingDeficienciesTable);
